import { render, staticRenderFns } from "./UserInfoInput.vue?vue&type=template&id=67276fbb&scoped=true&"
import script from "./UserInfoInput.vue?vue&type=script&lang=js&"
export * from "./UserInfoInput.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoInput.vue?vue&type=style&index=0&id=67276fbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67276fbb",
  null
  
)

export default component.exports